const openNewBlankTab = (url: string): void => {
    try {
        window.open(url, '_blank', 'noreferrer,noopener');
    } catch {} // eslint-disable-line no-empty
};

export default openNewBlankTab;
